module.exports = __webpack_public_path__ + "img/AutoIncrement.50493615.svg";